var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "mx-1": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { xs12: "", md6: "" } },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("1")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text " }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmCommentTitle1) + " ?"))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { required: "", label: _vm.lblSetting.ticketName } },
            [
              _c("v-text-field", {
                attrs: {
                  counter: _vm.textConfigs.input,
                  maxlength: _vm.textConfigs.input,
                  required: "",
                  rules: _vm.dtRules.nameRules,
                  solo: ""
                },
                model: {
                  value: _vm.Subject,
                  callback: function($$v) {
                    _vm.Subject = $$v
                  },
                  expression: "Subject"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            {
              attrs: {
                required: "",
                label: _vm.lblSetting.ticketDescriptionOfTheProblem
              }
            },
            [
              _c("v-textarea", {
                attrs: {
                  name: "description",
                  counter: _vm.textConfigs.textarea,
                  maxlength: _vm.textConfigs.textarea,
                  rows: 4,
                  required: "",
                  solo: "",
                  rules: _vm.dtRules.descriptionRules
                },
                model: {
                  value: _vm.Description,
                  callback: function($$v) {
                    _vm.Description = $$v
                  },
                  expression: "Description"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "form-section",
          attrs: { "pl-3": "", xs12: "", md6: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { "mb-3": "" } },
            [
              _c("v-layout", { staticClass: "title--text-custom" }, [
                _c("div", { staticClass: "primary--text" }, [_vm._v("2")]),
                _vm._v(" "),
                _c("div", { staticClass: "red--text" }, [_vm._v(".")])
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.$t(_vm.lblSetting.bmOptions)))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label-vertical",
            { attrs: { label: _vm.lblSetting.ticketAttachDocuments } },
            [
              _c("base-attachment-button", {
                attrs: {
                  "custom-class": "upload-buttons",
                  multiple: "",
                  accept:
                    "video/*,image/*,.pdf,.doc,.docx,.xml.xlsx,.xls,.ppt, .pptx,.txt,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                },
                model: {
                  value: _vm.vAttachments,
                  callback: function($$v) {
                    _vm.vAttachments = $$v
                  },
                  expression: "vAttachments"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.displaySwitchCreateTicket
            ? _c("v-switch", {
                staticClass: "ml-3 mt-4",
                attrs: {
                  "hide-details": true,
                  label: _vm.$t(_vm.lblSetting.bmCommentCreateTicket),
                  color: "primary"
                },
                on: { change: _vm.changeSwitchCreateTicket },
                model: {
                  value: _vm.CreateTicket,
                  callback: function($$v) {
                    _vm.CreateTicket = $$v
                  },
                  expression: "CreateTicket"
                }
              })
            : _c(
                "base-control-label-vertical",
                { attrs: { label: _vm.lblSetting.bmCommentLinkedTicket } },
                [
                  _c(
                    "v-chip",
                    {
                      staticClass: "white--text mx-0 mb-3",
                      attrs: {
                        color: _vm.getStateTicketColor(_vm.commentSelected),
                        label: "",
                        small: ""
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.getTicketRef(_vm.commentSelected.ticket)) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              ),
          _vm._v(" "),
          _vm.CreateTicket
            ? _c("v-switch", {
                staticClass: "ml-3 mt-4",
                attrs: {
                  "hide-details": false,
                  label: _vm.$t(_vm.lblSetting.bmCommentAddDateEnd),
                  color: "primary"
                },
                on: { change: _vm.changeSwitchEndDate },
                model: {
                  value: _vm.sendDateTicket,
                  callback: function($$v) {
                    _vm.sendDateTicket = $$v
                  },
                  expression: "sendDateTicket"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.sendDateTicket
            ? _c(
                "base-control-label-vertical",
                {
                  attrs: {
                    xs4: "",
                    label: "" + _vm.$t(_vm.lblSetting.bmCommentDateEnd)
                  }
                },
                [
                  _c("base-datetime-picker-solo-vertical", {
                    model: {
                      value: _vm.DateEndTicket,
                      callback: function($$v) {
                        _vm.DateEndTicket = $$v
                      },
                      expression: "DateEndTicket"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4546cc13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4546cc13","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/components/bm-comment-modal-vertical/template.html
// module id = null
// module chunks = 